import { useEffect } from 'react';
import { ERA_SKILLS } from '../data/eraPipeline';

/* Skill library console: the rail lists every skill TeamGrid built from a pattern,
   the detail pane shows the pattern behind the selected one and what it has run.
   Auto-advances, pauses on hover, and is fully clickable. */
export default function useEraPipeline() {
  useEffect(() => {
    const railEl = document.getElementById('spRail');
    const detEl = document.getElementById('spDetail');
    if (!railEl || !detEl) return undefined;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const timers = [];
    const intervals = [];
    const cleanups = [];

    const CHK =
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" d="M2 8.5 6 12.5 14 3.5"/></svg>';

    /* build the rail once */
    railEl.innerHTML = '';
    const btns = ERA_SKILLS.map((s, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sk';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.innerHTML =
        `<span class="sk-dot" style="background:${s.c}"></span>` +
        `<span class="sk-t"><span class="sk-n">${s.name}</span>` +
        `<span class="sk-s">${s.team} · ${s.runs.length} run${s.runs.length > 1 ? 's' : ''}</span></span>` +
        `<span class="sk-badge ${s.status}">${s.status}</span>`;
      railEl.appendChild(b);
      return b;
    });

    const render = (i) => {
      const s = ERA_SKILLS[i];
      btns.forEach((b, j) => {
        b.classList.toggle('on', j === i);
        b.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      detEl.style.setProperty('--sc', s.c);
      detEl.innerHTML =
        `<div class="sd-h"><h3>${s.name}</h3><span class="sk-badge ${s.status}">${s.status}</span></div>` +
        `<p class="sd-what">${s.what}</p>` +
        `<span class="sd-lbl">BUILT FROM THIS PATTERN</span>` +
        `<div class="sd-pat"><span class="sd-src"><i></i>${s.src}</span>` +
        `<span class="sd-ptxt">${s.pattern}</span>` +
        `<span class="sd-ev">${s.evidence.map((e) => `<span>${e}</span>`).join('')}</span></div>` +
        `<span class="sd-lbl">WHAT IT HAS RUN</span>` +
        `<div class="sd-runs">${s.runs
          .map((r) => {
            const pend = /await|left|Proposed|Learning/i.test(r.r + r.t);
            return (
              `<div class="sd-run${pend ? ' pend' : ''}">` +
              `<span class="rt">${r.t}</span>` +
              `<span class="rd">${r.do}</span>` +
              `<span class="rr">${pend ? '' : CHK}${r.r}</span></div>`
            );
          })
          .join('')}</div>`;
      if (!reduce) {
        detEl.classList.remove('swap');
        void detEl.offsetWidth;
        detEl.classList.add('swap');
      }
    };

    let cur = 0;
    render(0);

    btns.forEach((b, i) => {
      const onClick = () => {
        cur = i;
        render(cur);
      };
      b.addEventListener('click', onClick);
      cleanups.push(() => b.removeEventListener('click', onClick));
    });

    if (!reduce) {
      let paused = false;
      const enter = () => {
        paused = true;
      };
      const leave = () => {
        paused = false;
      };
      const panel = railEl.closest('.skillpanel');
      panel?.addEventListener('mouseenter', enter);
      panel?.addEventListener('mouseleave', leave);
      cleanups.push(() => {
        panel?.removeEventListener('mouseenter', enter);
        panel?.removeEventListener('mouseleave', leave);
      });
      intervals.push(
        setInterval(() => {
          if (paused || document.hidden) return;
          cur = (cur + 1) % ERA_SKILLS.length;
          render(cur);
        }, 4200),
      );
    }

    return () => {
      timers.forEach(clearTimeout);
      intervals.forEach(clearInterval);
      cleanups.forEach((fn) => fn());
    };
  }, []);
}
